// SPDX-License-Identifier: AGPL-3.0-or-later

import {ReverseImageSearchMenuItems} from '@app/features/ui/action_menu/items/ReverseImageSearchMenuItems';
import type {Profile} from '@app/features/user/models/Profile';
import type {User} from '@app/features/user/models/User';
import * as AvatarUtils from '@app/features/user/utils/AvatarUtils';
import {useLingui} from '@lingui/react/macro';
import {observer} from 'mobx-react-lite';
import type React from 'react';

interface UserImageMenuItemsProps {
	user: User;
	profile?: Profile | null;
	onClose: () => void;
	variant?: 'all' | 'avatar' | 'banner';
}
export function getUserMenuBannerHash(user: User, profile?: Profile | null): string | null {
	return profile?.userProfile?.banner ?? user.banner ?? null;
}
export const UserImageMenuItems: React.FC<UserImageMenuItemsProps> = observer(
	({user, profile, onClose, variant = 'all'}) => {
		const {t} = useLingui();
		const avatarUrl = user.avatar ? AvatarUtils.getUserAvatarURL({id: user.id, avatar: user.avatar}) : null;
		const banner = getUserMenuBannerHash(user, profile);
		const bannerUrl = banner ? AvatarUtils.getUserBannerURL({id: user.id, banner}) : null;
		const showAvatar = variant !== 'banner';
		const showBanner = variant !== 'avatar';
		return (
			<>
				{showAvatar && avatarUrl && (
					<ReverseImageSearchMenuItems
						imageUrl={avatarUrl}
						onClose={onClose}
						wrapInGroup
						includeCopyAndOpen
						copyLabel={t`Copy Avatar URL`}
						openLabel={t`Open Avatar in Browser`}
						defaultLabel={t`Reverse Search Avatar`}
					/>
				)}
				{showBanner && bannerUrl && (
					<ReverseImageSearchMenuItems
						imageUrl={bannerUrl}
						onClose={onClose}
						wrapInGroup
						includeCopyAndOpen
						copyLabel={t`Copy Banner URL`}
						openLabel={t`Open Banner in Browser`}
						defaultLabel={t`Reverse Search Banner`}
					/>
				)}
			</>
		);
	},
);
